import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'mt-rating',
    templateUrl: './rating.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RatingComponent implements OnInit {
  @Input() rating?: number;
  @Input() starCount: number;
  @Input() color?: string;
  @Output() ratingUpdated = new EventEmitter();

  private snackBarDuration: number = 9000;
  ratingArr = [];

  constructor(private snackBar: MatSnackBar) {}

  ngOnInit() {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }
  onClick(rating: number) {
    this.snackBar.open('You rated ' + rating + ' / ' + this.starCount, 'Got it', {
      duration: this.snackBarDuration
    });
    this.ratingUpdated.emit(rating);
    return false;
  }

  showIcon(index: number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }
}
